import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import OrganisationProfileForm from "./OrganisationProfileForm";

const SettingsRoute = () => {
  console.log("SettingsRoute component rendered");
const { id } = useParams(); // <-- get id from route

  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchClient() {
      console.log("Starting fetchClient");
      try {
        const res = await fetch("/api/clients/current");
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const data = await res.json();
        const realClient = data.client || data;
        console.log("Fetched client data from API:", realClient);

        setClient(realClient);
      } catch (error) {
        console.error("Error fetching client:", error);
        setClient(null);
      } finally {
        setLoading(false);
      }
    }
    fetchClient();
  }, []);

  const handleSave = async (updatedClient) => {
  try {
    if (!updatedClient || !updatedClient.client_id) {
      alert("Client ID missing — cannot save.");
      return;
    }
const res = await fetch(`/api/clients/${id}`, {
    // const res = await fetch(`/api/clients/${updatedClient.client_id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedClient),
    });

    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(`HTTP error! status: ${res.status} - ${errorText}`);
    }

    const savedClient = await res.json();

    setClient(savedClient.client || savedClient);
    alert("Profile saved successfully!");
  } catch (error) {
    alert("Failed to save profile: " + error.message);
  }
};


if (loading) return <p>Loading client data...</p>;
if (!client) return <p>No client data found.</p>;

return <OrganisationProfileForm client={client} onSave={handleSave} />;
}

export default SettingsRoute;
